<template>
  <div>
    <legend v-if="uploadTitle">
      <v-row no-gutters class="ml-1 mr-2">
        <i class="ml-2">{{ uploadTitle }}</i>
      </v-row>
    </legend>

    <!-- COMPTEUR fichiers : affiché pour tous les modes -->
    <div class="file-count-badge mb-2" :style="{ visibility: internalValue.files && internalValue.files.length > 0 ? 'visible' : 'hidden' }">
      <v-icon x-small class="mr-1">check_circle</v-icon>
      {{ pluralize(internalValue.files.length, ['Fichier', 'déposé']) }} ({{ internalValue.files.length }})
    </div>
    <div :class="['dropZone', dragging ? 'dropZone-over' : '', loading ? 'dropZone-disabled' : '']" @dragenter="!loading && (dragging = true)"
      @dragleave="dragging = false">
      <div class="dropZone-info" @drag="!loading && onChange">
        <v-row no-gutters align="center" justify="center">
          <v-icon>cloud_upload</v-icon>
          <span class="dropZone-title ml-2">{{ `Déposez ${multiple ? 'vos' : 'votre'} ${multiple ? 'fichiers' : 'fichier'} ou cliquez pour l'ajouter` }}</span>
        </v-row>
        <div class="dropZone-upload-limit-info">
          <div class="dropZone-upload-accepted-formats">Format autorisés : {{ acceptedFormats }}</div>
        </div>
      </div>
      <input type="file" :multiple="multiple" @change="onChange" :accept="formats" :disabled="loading">
    </div>

    <!-- LISTE des fichiers (uploadés ou en attente) -->
    <template v-if="loading">
      <div class="mt-2">
        <v-skeleton-loader v-for="n in 2" :key="'file-skel-' + n" type="list-item-avatar" class="mb-1" />
      </div>
    </template>
    <div class="uploadedFile-info scroller-bar mt-2" :style="maxHeight ? { maxHeight } : {}" v-else-if="internalValue.files && internalValue.files.length > 0">
      <v-list dense>
        <template v-for="(file, index) in internalValue.files">
          <v-row :key="'file-info-' + index" no-gutters align="center" class="flex-nowrap">
            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <span class="file-name text-truncate flex-shrink-1" style="min-width:0" v-if="!file.uploaded" v-bind="attrs" v-on="on"><b> {{ file.nom }}</b> ({{ file.size | size }})</span>
                <span class="file-name text-truncate flex-shrink-1" style="min-width:0" v-else v-bind="attrs" v-on="on"><b> {{ file.nom }}</b> {{ file.date | date }}</span>
              </template>
              <span>
                <span class="file-name" v-if="!file.uploaded"><b> {{ file.nom }}</b> ({{ file.size | size }})</span>
                <span class="file-name" v-else><b> {{ file.nom }}</b> {{ file.date | date }}</span>
              </span>
            </v-tooltip>
            <v-spacer />
            <v-btn v-if="file.uploaded" text small color="grey" class="flex-shrink-0" @click="download(file)" :disabled="downloading">
              <v-icon small v-if="!downloading">download</v-icon>
              <v-progress-circular v-else size="16" width="2" indeterminate color="grey" />
            </v-btn>
            <v-btn v-if="!file.uploaded" text small color="primary" class="flex-shrink-0" :disabled="uploading" @click="upload">
              <v-icon small>upload</v-icon>
            </v-btn>
            <v-btn text small class="grey--text flex-shrink-0" @click="removeFile(file)">
              <v-icon v-if="!removing">delete</v-icon>
              <v-progress-circular v-else size="23" color="grey" indeterminate />
            </v-btn>
          </v-row>
          <v-divider :key="'file-divider-' + index" />
        </template>
      </v-list>
    </div>
  </div>
</template>
<script>
import CommonUtils from '@/utils/commonUtils'
import PlateauService from '@/services/PlateauxService'
import NettoyageService from '@/services/NettoyageService'
import PMSService from '@/services/PMSService'
import PLUService from '@/services/PLUService'
import InputComponentMixin from '@/mixins/InputComponentMixin'
import moment from 'moment'
import shortUuid from 'short-uuid'
export default {
  filters: {
    size (size) {
      return CommonUtils.formatBytes(size)
    },
    date (date) {
      return date ? `(${moment(date).format('[envoyé le ] DD/MM/YYYY [-] HH[h]mm')})` : ''
    }
  },
  props: ['formats', 'uploadTitle', 'multiple', 'service', 'model', 'code', 'loading', 'pluType', 'maxHeight'],
  mixins: [InputComponentMixin],
  data () {
    return {
      dragging: false,
      uploading: false,
      downloading: false,
      removing: false,
      services: [
        { name: 'plu', service: PLUService },
        { name: 'plateau', service: PlateauService },
        { name: 'nettoyage', service: NettoyageService },
        { name: 'pms', service: PMSService },
      ]
    }
  },
  methods: {
    pluralize (value, array) {
      return CommonUtils.pluralize(value, array)
    },
    onChange (e) {
      var files = e.target.files || e.dataTransfer.files

      if (!files.length) {
        this.dragging = false
        return
      }
      this.createFile(files)
    },
    download (file) {
      this.downloading = true
      return this.services.filter(service => service.name == this.service)[0].service.download(file)
        .then(() => {
          this.$toast.success('Fichier téléchargé avec succès')
          this.downloading = false
        })
        .catch((err) => this.$toast.error(`Erreur : ${err}`))
    },
    upload () {
      this.uploading = true
      // Handle duplicate names
      const filesToSend = this.internalValue.files.filter(file => !file.uploaded)
      return Promise.all(filesToSend.map((fileToSend) => {
        return this.services.filter(service => service.name == this.service)[0].service.upload(fileToSend, this.model.idmodel, this.model.clientid, this.code, fileToSend.nom.split('.').slice(0, -1).join('.'), fileToSend.nom.split('.').pop(), this.pluType)
      }))
        .then((uploadedFiles) => {
          const validFiles = uploadedFiles.filter(f => f && f.nom)
          if (validFiles.length === 0) {
            this.$toast.error('Erreur lors de l\'envoi du fichier')
            this.uploading = false
            return
          }
          const updatedFiles = this.internalValue.files.map(file => {
            const match = validFiles.find(u => u.nom === file.nom)
            return match ? { ...match, uploaded: true } : file
          })
          this.internalValue = { ...this.internalValue, files: updatedFiles }
          this.updateValue({ ...this.internalValue, files: updatedFiles })
          this.$toast.success(`${this.pluralize(validFiles.length, ['Fichier', 'envoyé'])} (${validFiles.length})`)
          this.uploading = false
        })
        .catch((err) => {
          this.uploading = false
          this.$toast.error(`Erreur : ${err.message || err}`)
        })
    },
    createFile (fileValue) {
      const fileValueNames = this.internalValue.files.length > 0 ? this.internalValue.files.map(file => file.nom) : []
      const filteredFiles = this.internalValue.files.length > 0 ? Array.from(fileValue).filter(file => !fileValueNames.includes(file.name)) : Array.from(fileValue)
      return new Promise((resolve, reject) => {
        if (filteredFiles.length > 0) {
          resolve(filteredFiles.map(file => {
            const currentExtension = file.name.match(/\.[0-9a-z]+$/i)[0].replace(/[.]/g, '')
            const extensions = this.formats.map(format => format.replace(/[.,]/g, '')).join('|')
            const regex = new RegExp(`${extensions}`)
            if (!currentExtension.match(regex)) {
              this.$toast.warning('Veuillez choisir un fichier respectant le format demandé')
              this.dragging = false
              return
            }
            const short = shortUuid.generate().substring(0, 5)
            const uniqueFile = { file: file, nom: `${file.name.split('.').slice(0, -1)[0]}-${short}.${file.name.split('.').pop()}`, size: file.size, uploaded: false }
            this.internalValue = { ...this.internalValue, files: this.internalValue.files.concat(uniqueFile) }
          }))
        }
        if (filteredFiles.length === 0) {
          reject()
        }
      }).then(() => {
        this.dragging = false
        this.upload()
      })
    },
    removeFile (f) {
      this.removing = true
      return Promise.all(this.internalValue.files.filter(file => file.nom === f.nom).map((fileToSend) => {
        return this.services.filter(service => service.name == this.service)[0].service.remove(fileToSend, this.model.idmodel, this.code)
      }))
        .then(() => {
          this.internalValue = { ...this.internalValue, files: this.internalValue.files.filter(file => file.nom !== f.nom) }
          this.updateValue({ ...this.internalValue, files: this.internalValue.files.filter(file => file.nom !== f.nom) })
          setTimeout(() => {
            this.$toast.info('Fichier supprimé')
            this.removing = false
          }, 1500)
        })
        .catch((err) => this.$toast.error(err instanceof Error ? err.message : 'Impossible de supprimer le fichier'))

    },
  },
  computed: {
    acceptedFormats () {
      return this.formats.map(format => format).join(',')
    },
    sentFiles () {
      return this.internalValue.files && this.internalValue.files.filter(file => file.uploaded).length === this.internalValue.files.length
    }

  }
}
</script>
<style lang="scss" scoped>
@import "../assets/app.scss";
@import "../assets/scroller.scss";

.dropZone {
  height: 150px;
  position: relative;
  border: 2px dashed #eee;
  border-radius: 8px;
  background-color: #F9FAFB;
  transition: border-color 0.25s ease, background-color 0.25s ease;
}

.dropZone:hover {
  border: 2px solid var(--v-secondary-base);
  background-color: color-mix(in srgb, var(--v-secondary-base) 30%, transparent)
}

.dropZone:hover .dropZone-title {
  color: var(--v-primary-base);
  font-weight: 700;
}

.dropZone-info {
  color: #A8A8A8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.dropZone-title {
  color: #787878;
  font-size: 1.1rem;
}

.drop-success {
  // color: #4CAF50;
  color: #787878;
  font-weight: 600;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.dropZone-upload-accepted-formats {
  font-size: 0.8rem;
  color: #A8A8A8;
}

.dropZone-over {
  opacity: 0.8;
}

.dropZone-disabled {
  opacity: 0.5;
  pointer-events: none;
  filter: grayscale(0.4);
}

.dropZone-uploaded {
  height: 150px;
  position: relative;
  border: 2px dashed #eee;
  background-color: #eee;
  border-radius: 8px;
}

.dropZone-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #A8A8A8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.file-count-badge {
  display: inline-flex;
  align-items: center;
  background-color: #e8f5e9;
  color: #2e7d32;
  border: 1px solid #a5d6a7;
  border-radius: 20px;
  padding: 2px 10px;
  font-size: 0.82rem;
  font-weight: 600;

  .v-icon {
    color: #2e7d32;
    font-size: 14px;
  }
}

.files-uploaded {
  font-size: 1.1rem;
  background-color: #eee;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;

  span {
    font-size: 1.1rem;
    margin: 5px;
  }
}

.uploadedFile-info {
  overflow-y: auto;
  max-height: 180px;
}

.file-name {
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align:start;
}
</style>
